import { Modal, Form, Input, Select, App } from 'antd';
import { useAddAdminUser } from '@/hooks/useAdminUsers';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function AddAdminModal({ open, onClose }: Props) {
  const { message } = App.useApp();
  const [form] = Form.useForm<{
    email: string;
    role: 'admin' | 'super_admin';
    display_name?: string;
  }>();
  const mut = useAddAdminUser();

  async function submit() {
    const v = await form.validateFields();
    try {
      await mut.mutateAsync({
        email: v.email.trim().toLowerCase(),
        role: v.role,
        display_name: v.display_name?.trim() || undefined,
      });
      message.success('Admin added');
      form.resetFields();
      onClose();
    } catch (e) {
      message.error((e as Error).message);
    }
  }

  return (
    <Modal
      open={open}
      title="Add admin user"
      destroyOnHidden
      onCancel={onClose}
      onOk={submit}
      confirmLoading={mut.isPending}
    >
      <Form form={form} layout="vertical" initialValues={{ role: 'admin' }}>
        <Form.Item label="Email" name="email" rules={[{ required: true, type: 'email' }]}>
          <Input autoFocus type="email" />
        </Form.Item>
        <Form.Item label="Role" name="role" rules={[{ required: true }]}>
          <Select
            options={[
              { value: 'admin', label: 'admin (read/write content)' },
              {
                value: 'super_admin',
                label: 'super_admin (also manages users + deletes languages/investors)',
              },
            ]}
          />
        </Form.Item>
        <Form.Item label="Display name (optional)" name="display_name">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}
